import { render, staticRenderFns } from "./FrontServiceBehavioralRecord.vue?vue&type=template&id=71748c7b&scoped=true"
import script from "./FrontServiceBehavioralRecord.vue?vue&type=script&lang=js"
export * from "./FrontServiceBehavioralRecord.vue?vue&type=script&lang=js"
import style0 from "./FrontServiceBehavioralRecord.vue?vue&type=style&index=0&id=71748c7b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71748c7b",
  null
  
)

export default component.exports